import React from 'react';
import '../styles/trendingSearches.css';

const FlameIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M13.5 0.7s.8 2.6.8 4.7c0 2-1.3 3.7-3.4 3.7-2.1 0-3.6-1.7-3.6-3.7l0-0.4C5.3 7.4 4 10.2 4 13.2 4 17.6 7.6 21.2 12 21.2s8-3.6 8-8c0-5.4-3.9-9.9-6.5-12.5z" />
  </svg>
);

const UpArrow = () => (
  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M7 17 17 7" />
    <path d="M9 7h8v8" />
  </svg>
);

/**
 * TrendingSearches — glass dropdown of ranked trending queries shown beneath
 * the search bar. Renders nothing when there is no data (hide-when-empty).
 *
 * @param {Array<{name:string, meta?:string, delta?:string}>} items
 * @param {(query:string) => void} onSelect
 */
const TrendingSearches = ({ items = [], onSelect }) => {
  if (!items.length) return null;

  return (
    <div className="trending-panel" role="listbox" aria-label="Trending searches">
      <div className="trending-head">
        <FlameIcon />
        TRENDING NOW
      </div>
      {items.map((t, i) => (
        <button
          key={t.name}
          type="button"
          role="option"
          className="trend-row"
          // onMouseDown fires before the input's blur, so the panel doesn't
          // close before the selection is registered.
          onMouseDown={(e) => {
            e.preventDefault();
            onSelect(t.name);
          }}
        >
          <span className="trend-rank">{i + 1}</span>
          <span className="trend-main">
            <span className="trend-name">{t.name}</span>
            {t.meta ? <span className="trend-meta">{t.meta}</span> : null}
          </span>
          {t.delta ? (
            <span className="trend-delta"><UpArrow />{t.delta}</span>
          ) : null}
        </button>
      ))}
    </div>
  );
};

export default TrendingSearches;
